module.exports = __webpack_public_path__ + "img/menu_icon_home.4dfd5e75.svg";